export const handleConditionalFormFields = () => {
	const form = document.querySelector( 'form.woocommerce-form-register' );
	if ( ! form ) {
		return;
	}

	const conditionalFields = form.querySelectorAll(
		'[data-validate-conditional]'
	);
	conditionalFields.forEach( ( conditionalField ) => {
		const { field, value } = conditionalField.dataset;

		const values = value.split( ',' ),
			target = document.getElementById( `${ field }_field` ),
			input = document.getElementById( field );

		conditionalField.onchange = ( e ) =>
			toggleConditionalField( conditionalField, input, target, values );

		toggleConditionalField( conditionalField, input, target, values );
	} );
};

const toggleConditionalField = ( conditionalField, input, target, values ) => {
	console.log( conditionalField.value, values );
	if ( values.includes( conditionalField.value ) ) {
		target.classList.remove( 'd-none' );
		return;
	}
	target.classList.add( 'd-none' );
	input.value = '';
};
